import voca from "voca";
import numeral from "numeral";
import { KeyResultType, KeyResultBinaryChoice } from "@teaming/common-enums";

export const KeyResultDisplayFormat = {
	[ KeyResultType.CURRENCY ]: value => numeral( value ).format( "$0,0" ),
	[ KeyResultType.NUMERIC ]: value => numeral( value ).format( "0,0" ),
	[ KeyResultType.PERCENTAGE ]: value => `${ value }%`,
	// TODO: this should be translated with i18n, but
	// quick hacking it for now
	[ KeyResultType.BINARY ]: value => {
		// convert numeric values to enum first, if necessary
		if ( [ 1, 0, ].includes( numeral( value ).value() ) ) {
			value = ( value === 1 ) ?
				KeyResultBinaryChoice.COMPLETE :
				KeyResultBinaryChoice.INCOMPLETE;
		}
		return voca.titleCase( value );
	},
};

/** @deprecated */
export const KeyResultDisplayFormatType = {
	[ KeyResultType.CURRENCY ]: "$0,0",
	[ KeyResultType.NUMERIC ]: "0,0",
	[ KeyResultType.PERCENTAGE ]: "0%",
};

/** @deprecated */
export const KeyResultValueFormatType = {
	[ KeyResultType.CURRENCY ]: "0,0",
	[ KeyResultType.NUMERIC ]: "0,0",
	[ KeyResultType.PERCENTAGE ]: "0",
};
